export const ENTITY_AVATAR_SIZE = {
  XXSMALL: 'xxsmall',
  XSMALL: 'xsmall',
  SMALL: 'small',
  SELECT: 'select',
  MEDIUM: 'medium',
  LARGE: 'large',
  DEFAULT: 'default'
};
